//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ValidationCard from '~/components/Dashboard/Employee/Supervisor/ValidationCard.vue'
import SectionCardsHeader from '~/components/Dashboard/Employee/SectionCardsHeader.vue'
import SectionCards from '~/components/Dashboard/Employee/SectionCards.vue'
export default {
  components: {
    ValidationCard,
    SectionCardsHeader,
    SectionCards,
  },
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },

  computed: {
    userId() {
      return this.$strapi.user.id
    },
    projectId() {
      if (!this.$strapi.user.project) {
        return null
      }
      return this.$strapi.user.project.id || this.$strapi.user.project
    },
  },
  methods: {},
}
